class BundleCard extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.product) {
      this.product = JSON.parse(this.dataset.product);
    }

    this.selectedVariantId = null;

    this.$addButton = this.querySelector('[name="add"]');
    this.$addButton?.addEventListener('click', (event) => {
      this.addToBundle();
    });

    this.$variantSelect = this.querySelector('[name="variant"]');
    this.$variantSelect?.addEventListener('change', (event) => {
      this.changeVariant(this.$variantSelect.value);
    });

    this.$removeButton = this.querySelector('[name="remove"]');
    this.$removeButton?.addEventListener('click', (event) => {
      this.removeFromBundle();
    });
  }

  addToBundle() {
    if (this.$variantSelect) this.$variantSelect.classList.add('show');
    if (this.$addButton) this.$addButton.style.display = 'none';
    if (this.$removeButton) this.$removeButton.style.display = 'block';
    this.changeVariant(this.$variantSelect.value)
  }

  changeVariant(variantId) {
    this.selectedVariantId = variantId;
    this.dispatchEvent(new CustomEvent('variant-change', { 
      detail: { 
        productId: this.product.id,
        variant: this.product.variants.find(variant => variant.id === parseInt(variantId)),
        newProduct: this.newProduct
      } 
    }))
  }

  removeFromBundle() {
    if (this.$variantSelect) this.$variantSelect.classList.remove('show');
    if (this.$addButton) this.$addButton.style.display = 'block';
    if (this.$removeButton) this.$removeButton.style.display = 'none';
    this.changeVariant(null)
  }
}

customElements.define('bundle-card', BundleCard); 